import { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { useLockFn } from 'ahooks';
import { Button } from '@leadsnavi/ui-kit';
import { ArrowUp } from 'lucide-react';
import { chatEmitter } from '../store';

interface ChartInputProps {
  /** 按钮置灰显示 + 转圈动效（请求发送中，禁用态） */
  isSending?: boolean;
  /** AI 正在回复中，可点击暂停 */
  isResponding?: boolean;

  onSend?: (input: string) => Promise<void>;
  onAbort?: () => void;
}
export const ChartInput: React.FC<ChartInputProps> = props => {
  const { isSending, isResponding, onSend, onAbort } = props;
  const [input, setInput] = useState('');
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  //   自动调整高度
  const autoResize = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      const height = textAreaRef.current.scrollHeight;
      textAreaRef.current.style.height = `${height <= 100 ? height : 100}px`;
    }
  };
  useEffect(() => {
    chatEmitter.on('copy', text => {
      setInput(text);
    });
    return () => {
      chatEmitter.off('copy');
    };
  }, []);
  // 监听输入变化
  useEffect(() => {
    autoResize();
  }, [input]);

  const onClick = useLockFn(async () => {
    // 如果正在发送提问时，直接返回
    if (isSending) {
      return;
    }
    // 如果正在接收回复时，点击发送会取消当前回复
    if (isResponding) {
      onAbort?.();
      return;
    }
    await handleSendAction();
  });

  const handleSendAction = useLockFn(async () => {
    if (isSending || isResponding) {
      console.log('A reply is currently being generated or a new message is being sent; you cannot send new messages.');
      return;
    }
    // 如果输入为空，不发送
    if (!input) return;
    await onSend?.(input);
    setInput('');
  });

  const canClick = isResponding || (input.trim() !== '' && !isSending);
  return (
    // box-shadow: 0 4px 10px -4px rgba(0, 0, 0, 0.10); 输出tailwindcss

    <div className="flex  w-full justify-between items-center   pl-5 pr-4 py-3  overflow-hidden">
      <textarea
        value={input}
        ref={textAreaRef}
        rows={1}
        onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendAction();
          }
        }}
        className="border-none outline-none w-full resize-none es-scrollbar"
        onChange={e => setInput(e.target.value)}
        placeholder="Finding Suppliers..."
      />
      <Button
        onClick={onClick}
        loading={isSending}
        // 点击回车发送

        className={cn(' self-end flex items-center justify-center size-[30px]  rounded-full', {
          ' [background:var(--400-fill--,#A3A3A3)]     pointer-events-none': !canClick,
          ' cursor-pointer [background:var(---,#171717)]': canClick,
        })}
      >
        {!isSending && isResponding ? (
          <span className="size-[10px] shrink-0 rounded-[1px]   inline-block bg-white"></span>
        ) : null}
        {!isSending && !isResponding ? <ArrowUp color="#fff" size={14} /> : null}
      </Button>
    </div>
  );
};
